import {
  StringHHColonmm,
  StringHHmm,
  StringYYYYMM,
  StringYYYYMMDD,
  StringYYYYMMDDHHmm,
  StringYYYYMMDDWithDashes,
} from '../models/date-time';

export function toStringYYYYMM(value: string): StringYYYYMM {
  if (!/^\d{6}$/.test(value)) {
    throw new Error(`Invalid StringYYYYMM format: ${value}`);
  }
  return value as StringYYYYMM;
}

export function toStringYYYYMMDD(value: string): StringYYYYMMDD {
  if (!/^\d{8}$/.test(value)) {
    throw new Error(`Invalid StringYYYYMMDD format: ${value}`);
  }
  return value as StringYYYYMMDD;
}

export function toStringYYYYMMDDHHmm(value: string): StringYYYYMMDDHHmm {
  if (!/^\d{12}$/.test(value)) {
    throw new Error(`Invalid StringYYYYMMDDHHmm format: ${value}`);
  }
  return value as StringYYYYMMDDHHmm;
}

export function toStringYYYYMMDDWithDashes(value: string): StringYYYYMMDDWithDashes {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    throw new Error(`Invalid StringYYYYMMDDWithDashes format: ${value}`);
  }
  return value as StringYYYYMMDDWithDashes;
}

export function toStringHHmm(value: string): StringHHmm {
  if (!/^\d{4}$/.test(value)) {
    throw new Error(`Invalid StringHHmm format: ${value}`);
  }
  return value as StringHHmm;
}

export function toStringHHColonmm(value: string): StringHHColonmm {
  if (!/^\d{2}:\d{2}$/.test(value)) {
    throw new Error(`Invalid StringHHColonmm format: ${value}`);
  }
  return value as StringHHColonmm;
}
